export const noFileId = '00000000-0000-0000-0000-000000000000';

export const isFileExists = (id: string): boolean => id !== noFileId;
